import React from "react";

const HighlightWords = ({
  sentence,
  selectedWords,
  handleWordClick,
  submitted,
}) => {
  const renderSentence = () => {
    if (!sentence) {
      return null;
    }

    const regex = /(\S+)(<span[^>]*>.*?<\/span>)/gi;
    let match;
    const words = [];
    let lastIndex = 0;

    while ((match = regex.exec(sentence)) !== null) {
      const incorrectWord = match[1];
      const spanContent = match[2];
      const spanWord = spanContent.replace(/<span[^>]*>(.*?)<\/span>/, "$1");

      const beforeMatch = sentence.slice(lastIndex, match.index).trim();
      if (beforeMatch) {
        words.push(
          ...beforeMatch.split(" ").map((word) => ({
            word,
            isCorrect: false,
          }))
        );
      }

      words.push({ word: incorrectWord, isCorrect: true });
      words.push({ word: spanWord, isCorrect: false });

      lastIndex = regex.lastIndex;
    }

    const afterLastMatch = sentence.slice(lastIndex).trim();
    if (afterLastMatch) {
      words.push(
        ...afterLastMatch.split(" ").map((word) => ({
          word,
          isCorrect: false,
        }))
      );
    }

    return words.map((item, index) => (
      <span
        key={index}
        onClick={() => handleWordClick(index, item.isCorrect)}
        className={`mb-2 mr-1 inline-flex cursor-pointer rounded-md px-2 py-1 text-sm font-semibold leading-6 transition ${
          selectedWords.some((selected) => selected.index === index)
            ? submitted
              ? selectedWords.find((selected) => selected.index === index)
                  .isCorrect
                ? "bg-green-50 text-green-700 ring-1 ring-green-100"
                : "bg-red-50 text-red-700 ring-1 ring-red-100"
              : "bg-purple-50 text-purple-800 ring-1 ring-purple-100"
            : "text-gray-700 hover:bg-purple-50 hover:text-purple-800"
        }`}
      >
        {item.word}{" "}
      </span>
    ));
  };

  return (
    <section className="rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <div className="mb-4">
        <p className="text-sm font-semibold uppercase text-purple-700">
          Transcript
        </p>
        <h2 className="mt-1 text-lg font-extrabold text-gray-900">
          Click the incorrect words
        </h2>
      </div>

      <div className="flex flex-wrap rounded-md bg-slate-50 p-4 ring-1 ring-slate-100">
        {renderSentence()}
      </div>
    </section>
  );
};

export default HighlightWords;
